module.exports = __webpack_public_path__ + "static/pauloakenfold_0-d520832109ffff280c13997e1e6d3166.jpg";